export default function Track(event) {
   if (typeof window !== 'undefined' && window.iiAna) {
      window.iiAna('track', 'Forecasts-' + event);
   }
}
